import { useFeatureFlags } from '../../../utils/featureFlags';
import { useAuthUser } from '../../index';
import { useSuspenseFeatureAccess } from './useSuspenseFeatureAccess';

/**
 * Hook to check if policies feature is accessible.
 * Combines both feature access (from plan/subscription) and feature flag (for rollout control).
 *
 * @returns {boolean} Whether policies feature is accessible
 */
export function usePolicyAccess(): boolean {
	const { policiesAccess } = useSuspenseFeatureAccess();
	const { policyV2 } = useFeatureFlags();

	// Both the feature access (subscription) and feature flag must be enabled
	return !!policiesAccess && !!policyV2;
}

/**
 * Hook to check if policies feature is both accessible and enabled for the workspace.
 * Combines feature access, feature flag, and workspace-level enablement.
 *
 * @returns {boolean} Whether policies feature is accessible and enabled
 */
export function usePolicyEnabled(): boolean {
	const policyAccess = usePolicyAccess();
	const { workspace } = useAuthUser();

	return policyAccess && !!workspace?.policies_enabled;
}
